export default "__VITE_ASSET__ByIy78TM__"